/*
 * MIT License
 *
 * Copyright (c) 2022 яαvoroηα
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy of
 * this software and associated documentation files (the "Software"), to deal in
 * the Software without restriction, including without limitation the rights to use,
 * copy, modify, merge, publish, distribute, sublicense, and/or sell copies of the
 * Software, and to permit persons to whom the Software is furnished to do so,
 * subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS
 * FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR
 * COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN
 * AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH
 * THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
 */

//import '@css/drive.css'
import Guide from '@scripts/guide'

const { DEV } = import.meta.env

/**
 * Enable guide in dev mode
 */
//DEV && new Guide().start()
import { defineCustomElement } from '@scripts/defineCustomElementWithStyles.js'

import { createRouter, createWebHashHistory, } from "vue-router";

import MediaDriveComp from '@scripts/Components/MediaDrive.ce.vue'
import MediaSliderComp from '@scripts/Components/MediaSlider.ce.vue'

import MediaGrid from '@scripts/Components/MediaGrid.vue'
import MediaModal from '@scripts/Components/MediaModal.vue'
//import EmptyComp from '@scripts/Components/EmptyComp.vue'
import { createApp, getCurrentInstance, h } from 'vue';
import { createPinia } from 'pinia';
import { createVfm } from 'vue-final-modal'
//import ChildComponent from './ChildComponent.vue';
import { autoAnimatePlugin } from '@formkit/auto-animate/vue'

const vfm = createVfm()
const pinia = createPinia()

const routes = [
    {
        path: '',
        name: 'media-root',
        component: () => import( '@scripts/Components/MediaModal.vue' ),
    },
    {
        path: "/media/:slug",
        name: "media",
        component: () => import( '@scripts/Components/MediaModal.vue' ),
    },


];

const router = createRouter({
    history: createWebHashHistory(),
    routes,
});


const MediaDrive = defineCustomElement(MediaDriveComp,
    {
        components: {
            //'ChildComponent': ChildComponent
            //'MediaGrid': MediaGrid,
            'MediaModal': MediaModal
        },
        plugins: [pinia, router, vfm, autoAnimatePlugin]

    })
customElements.define('media-drive', MediaDrive)

const MediaSlider = defineCustomElement(MediaSliderComp,
    {
        components: {

        },
        plugins: []

    })
    customElements.define('media-slider', MediaSlider)
